'use client';

import { Button } from '@/components/ui/button';
import { Search } from 'lucide-react';

interface PageHeaderProps {
  /** 조회 버튼 클릭 핸들러 */
  onSearch?: () => void;
  /** 로딩 상태 (조회 버튼 비활성화) */
  isLoading?: boolean;
  /** 조회 버튼 외 추가 액션 버튼들 */
  actions?: React.ReactNode;
}

/**
 * 페이지 상단 액션 줄.
 *
 * 제목은 갖지 않는다. Breadcrumb 의 마지막 항목과 카드 헤더가 이미 화면 이름을 말하고 있어
 * 세 번째 제목은 세로 공간만 쓴다. ExpandableCard 가 이 컴포넌트를 Breadcrumb 과 같은 줄에
 * 배치하므로, 여기서는 오른쪽에 붙을 버튼들만 렌더한다.
 *
 * 조회 버튼이 없는 화면은 이 컴포넌트를 쓰지 않는다 - ExpandableCard 의 pageHeader 를 비우면 된다.
 */
export function PageHeader({ onSearch, isLoading = false, actions }: PageHeaderProps) {
  return (
    <div className='flex items-center gap-2'>
      {onSearch && (
        <Button
          onClick={onSearch}
          disabled={isLoading}
          className='flex items-center gap-2 bg-blue-600 text-white'
          size='sm'
        >
          <Search className='h-4 w-4' />
          조회
        </Button>
      )}
      {actions}
    </div>
  );
}
